const getFDAData = (state) =>
  __IS_COMPONENTS_PORTAL__
    ? state.variantResult?.genes?.[state.selectedGeneIndexClinical]
        ?.fda_pharmacogenomic_biomarkers
    : state?.variantResult?.fda_pharmacogenomic_biomarkers;

export { getFDAData };
